const frameTypes = {
    SINGLE_MAP: 'SINGLE_MAP',
    SWIPE: 'SWIPE_FRAME',
    SIDE_BY_SIDE_MAPS: 'SIDE_BY_SIDE_MAPS',
    MAP_EDITOR: 'MAP_EDITOR',
};

export default frameTypes;
